import styled from 'styled-components'

import { colors } from 'app/theme/colors'

export const DrawerInner = styled.div`
  width: 480px;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 20px 24px 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`

export const HeaderTitle = styled.div`
  font-family: AvenirDemi;
  font-size: 18px;
  color: ${colors.textPrimary || 'rgba(0, 0, 0, 0.86)'};
`

export const HeaderSub = styled.div`
  font-family: AvenirMedium;
  font-size: 12px;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.5)'};
  text-transform: lowercase;
  margin-top: 2px;
`

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 24px;
`

export const Loading = styled.div`
  text-align: center;
  font-family: AvenirMedium;
  font-size: 13px;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.5)'};
  padding: 40px 0;
`

export const Empty = styled.div`
  text-align: center;
  font-family: AvenirMedium;
  font-size: 13px;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.5)'};
  font-style: italic;
  padding: 40px 0;
`

export const Item = styled.div`
  padding: 10px 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.06);

  &:last-child {
    border-bottom: none;
  }
`

export const ItemTitle = styled.div`
  font-family: AvenirDemi;
  font-size: 13px;
  color: ${colors.textPrimary || 'rgba(0, 0, 0, 0.86)'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const ItemMeta = styled.div`
  font-family: AvenirMedium;
  font-size: 11px;
  color: ${colors.textTertiary || 'rgba(0, 0, 0, 0.55)'};
  margin-top: 3px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const StatusPill = styled.span`
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-family: AvenirDemi;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  background: ${(props) =>
    props.$status === 'active' ? 'rgba(16, 185, 129, 0.12)'
      : props.$status === 'paused' ? 'rgba(245, 158, 11, 0.15)'
      : props.$status === 'closed' || props.$status === 'terminated' ? 'rgba(0, 0, 0, 0.06)'
      : 'rgba(0, 0, 0, 0.06)'};
  color: ${(props) =>
    props.$status === 'active' ? '#0f8a64'
      : props.$status === 'paused' ? '#a86a13'
      : '#444'};
`
